import { Button, notification } from "antd";
import CustomForm from "../../../shared/components/CustomForm";
import React, { useContext, useEffect, useRef, useState } from "react";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import routes from "../../../engine/routes";
import { roles } from "../../../utils/constants";
import { http } from "../../../engine/api/http";
import { RenderInterpretesSchedules } from "./Prestation.selector.renders";
import dayjs from "../../../utils/dayjs";
import { AiFillCalendar } from "react-icons/ai";
import { useSelector } from "react-redux";
import { UserContext } from "../../../engine/context/User.context";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import { inputsSelector } from "./Prestation.selector.inputs";
import { useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";
import { DurationHourChecker } from "../PrestationDetail/DurationHourChecker";
import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../../../shared/components/CustomForm/form.helpers";

export function PrestationSelector(props) {
  const { user, configuration } = useContext(UserContext);
  const formRef = useRef(null);
  const formRef2 = useRef(null);
  const [shedules, setShedules] = React.useState([]);
  const [prestationSearch, setPrestationsSearch] = React.useState([]);
  const [dataForm, setDataForm] = useState({});
  const { id } = useParams();

  const navigate = useNavigate();

  const { prestation, loading } = useSelector(state => state.prestation);

  const {
    intervention: { startDate, endDate, location, extra },
  } = prestation;

  const getShedulesInterprete = async () => {
    try {
      let interprete = dataForm.interprete;
      const shedules = await http.get(
        `schedules/user/${interprete}?futur=true`,
      );

      const search = objectToUrlParams({
        interprete,
        tab: "total",
        sorter: {
          key: "finalStartDate",
          order: "descend",
        },
        rangeDate: [dayjs(), dayjs().add(12, "month")],
        currentPage: 1,
        pageSize: 1000,
      });
      const callPrestations = await http.get(`prestations/tab?${search}`);

      setPrestationsSearch(
        callPrestations.data.prestations.filter(e => e.status !== "cancel"),
      );
      setShedules(shedules.data);
    } catch (e) {
      console.log(e);
    }
  };

  const isInstitution = userHasLevel({
    not: {
      [roles.institution]: "", //
    },
  });

  useEffect(() => {
    if (id !== "new") {
      navigate(routes.prestations().selector.fallBack(id));
    }

    if (!isInstitution) {
      setDataForm({
        ...dataForm,
        institution: user.institution,
      });
    }
  }, []);

  useEffect(() => {
    if (dataForm.interprete !== undefined) {
      getShedulesInterprete();
    }
  }, [dataForm.interprete]);

  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledSchedules = current => {
    // Rule 2: Schedule must match
    // filter by schedule.type === "schedule"
    const dayOfWeek = dayjs(current)
      .locale("en")
      .format("dddd")
      .toLowerCase(); // get the day of the week as a lowercase string

    const matchingSchedules = shedules.filter(
      schedule =>
        schedule.type === "schedule" &&
        schedule.day.toLowerCase() === dayOfWeek,
    );

    // If there are no matching schedules for the day, the day is not available
    if (matchingSchedules.length === 0) {
      return true;
    }

    // Check if any matching schedule for the day is disabled
    for (let schedule of matchingSchedules) {
      if (schedule.disabled) {
        return true; // if schedule is disabled, the day is not available
      } else {
        return false;
      }
    }
    return true; // date is outside of any schedules or no matching times
  };
  const disabledHolidays = current => {
    // Rule 3: Not in holidays
    const holidays = shedules.filter(schedule => schedule.type === "holiday");
    for (let holiday of holidays) {
      const dateFrom = dayjs(holiday.dateFrom);
      const dateTo = dayjs(holiday.dateTo);
      if (current.isBetween(dateFrom, dateTo, "day", "()")) {
        return true; // date is within a holiday
      }
    }
    return false; // date is outside of any holidays
  };

  const disabledOthersPrestations = current => {
    // Rule 4: No other prestation in the same time
    for (let prestation of prestationSearch) {
      const start = dayjs(prestation.finalStartDate);
      const end = dayjs(prestation.finalEndDate);
      if (current.isBetween(start, end, null, "[]")) {
        return true; // date is during another prestation
      }
    }
    return false; // date is not during any other prestations
  };

  const disabledDatesByStatus = current => {
    if (onlyRoleMapping([roles.institution])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  const cache = {};

  const disabledDates = current => {
    const key = current.format("YYYY-MM-DD");

    // 🔹 1. si déjà calculé → on retourne direct
    if (cache[key] !== undefined) return cache[key];

    // 🔹 2. sinon, on calcule une fois avec toutes les règles
    const result =
      disabledDatesByStatus(current) ||
      disabledSchedules(current) ||
      disabledHolidays(current); // <-- ça reste utilisé ici

    // 🔹 3. on stocke le résultat
    cache[key] = result;

    return result;
  };

  const safetyTimeBetween = 0; // 60 minutes of safety time between prestations

  const disabledDateTimeHolidays = (
    date,
    key,
    availableHours,
    availableMinutes,
  ) => {
    const holidays = shedules.filter(schedule => schedule.type === "holiday");
    let refDate = dayjs(date);

    for (let holiday of holidays) {
      const dateFrom = dayjs(holiday.dateFrom);
      const dateTo = dayjs(holiday.dateTo);

      // Vérifier si la date est dans la période de vacances
      if (refDate.isBetween(dateFrom, dateTo, "day", "[]")) {
        const startHour = dateFrom.isSame(refDate, "day") ? dateFrom.hour() : 0;
        const endHour = dateTo.isSame(refDate, "day") ? dateTo.hour() : 23;
        const startMinute = dateFrom.isSame(refDate, "day")
          ? dateFrom.minute()
          : 0;
        const endMinute = dateTo.isSame(refDate, "day") ? dateTo.minute() : 59;

        availableHours = availableHours.filter(
          hour => hour < startHour || hour > endHour,
        );
        availableMinutes = availableMinutes.map((minutes, hour) => {
          if (hour === startHour) {
            return minutes.filter(minute => minute < startMinute);
          } else if (hour === endHour) {
            return minutes.filter(minute => minute > endMinute);
          } else if (hour > startHour && hour < endHour) {
            return [];
          }
          return minutes;
        });
      }
    }

    return {
      hours: availableHours,
      minutes: availableMinutes,
    };
  };

  const disabledDateTimeStart = (current, key) => {
    const date = dataForm[key];
    const dayOfWeek = dayjs(date)
      .locale("en")
      .format("dddd")
      .toLowerCase(); // get the day of the week as a lowercase string

    const matchingSchedules = shedules.filter(
      schedule =>
        schedule.type === "schedule" &&
        schedule.day.toLowerCase() === dayOfWeek,
    );

    // If there are no matching schedules for the day, disable all hours and minutes
    if (matchingSchedules.length === 0) {
      return {
        disabledHours: () => range(0, 24),
        disabledMinutes: () => range(0, 60),
      };
    }

    // Check if any matching schedule for the day is disabled
    for (let schedule of matchingSchedules) {
      if (schedule.disabled) {
        return {
          disabledHours: () => range(0, 24),
          disabledMinutes: () => range(0, 60),
        };
      }

      // Collect available hours and minutes
      let availableHours = [];
      let availableMinutes = Array(24)
        .fill()
        .map(() => []);

      for (let time of schedule.times) {
        const fromHour = time.from.hour;
        const toHour = time.to.hour;
        const fromMinute = time.from.minute;
        const toMinute = time.to.minute;

        for (let hour = fromHour; hour <= toHour; hour++) {
          availableHours.push(hour);
          if (hour === fromHour) {
            for (let minute = fromMinute; minute < 60; minute++) {
              availableMinutes[hour].push(minute);
            }
          } else if (hour === toHour) {
            for (let minute = 0; minute <= toMinute; minute++) {
              availableMinutes[hour].push(minute);
            }
          } else {
            for (let minute = 0; minute < 60; minute++) {
              availableMinutes[hour].push(minute);
            }
          }
        }
      }

      const refDate = dayjs(date);

      // Integrate prestations to disable time periods
      const prestationsForDay = prestationSearch.filter(prestation => {
        const prestationDay = dayjs(prestation.finalStartDate).startOf("day");
        return prestationDay.isSame(refDate.startOf("day"));
      });

      for (let prestation of prestationsForDay) {
        const start = dayjs(prestation.finalStartDate).subtract(
          safetyTimeBetween,
          "minutes",
        );

        const end = dayjs(prestation.finalEndDate).add(
          safetyTimeBetween,
          "minutes",
        );

        // Remove hours and minutes taken by prestation
        for (let hour = start.hour(); hour <= end.hour(); hour++) {
          if (!availableHours.includes(hour)) continue;

          if (hour === start.hour()) {
            // Remove minutes for the starting hour
            availableMinutes[hour] = availableMinutes[hour].filter(
              minute => minute < start.minute(),
            );
          } else if (hour === end.hour()) {
            // Remove minutes for the ending hour
            availableMinutes[hour] = availableMinutes[hour].filter(
              minute => minute > end.minute(),
            );
          } else {
            // Remove all minutes for hours between start and end
            availableMinutes[hour] = [];
          }

          // Remove the hour if there are no available minutes left
          if (availableMinutes[hour].length === 0) {
            availableHours = availableHours.filter(h => h !== hour);
          }
        }
      }

      let { hours, minutes } = disabledDateTimeHolidays(
        date,
        key,
        availableHours,
        availableMinutes,
      );

      const disabledHours = () =>
        range(0, 24).filter(hour => !hours?.includes(hour));
      const disabledMinutes = hour =>
        range(0, 60).filter(minute => !minutes[hour]?.includes(minute));

      return {
        disabledHours,
        disabledMinutes,
      };
    }
  };

  let interpreteRef = formRef?.current?._interpretes?.find(
    p => p?._id === dataForm?.interprete,
  );

  const dateSelectorInputs = [
    {
      parentLabel: t("PrestationSelector.dates"),
      children: [
        {
          disabledDate: disabledDates,
          disabledDateTime: current => disabledDateTimeStart(current, "start"),
          required: true,
          label: t("PrestationSelector.dateStart"),
          name: "start",
          value: undefined,
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "start",
                  "end",
                  user,
                  false,
                );
              },
            }),
          ],
          // value: dayjs(startDate),
          suffixIcon: <AiFillCalendar />,
          onChange: (props, ref) => {
            let end = formRef2.current.getFieldValue("end");
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }

            let extra = {};

            if (end === undefined) {
              let e = dayjs(val)
                .add(1, "hour")
                .format();
              extra.end = e;
              formRef2.current.setFieldValue("end", dayjs(val).add(1, "hour"));
              formRef2.current.setFieldValue(
                "endtime-picker",
                dayjs(val).add(1, "hour"),
              );
            }

            setDataForm({
              ...dataForm,
              start: val,
              ...extra,
            });
          },
          watch: "end",
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          col: 12,
          hidden: dataForm.interprete === undefined,
        },
        {
          hidden: dataForm.interprete === undefined,
          disabledDate: disabledDates,
          disabledDateTime: current => disabledDateTimeStart(current, "end"),
          value: undefined,
          // value: dayjs(endDate),
          required: true,
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "start",
                  "end",
                  user,
                  false,
                );
              },
            }),
          ],
          // label: "Date et heure de fin",
          label: t("PrestationSelector.dateEnd"),
          name: "end",
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }
            setDataForm({
              ...dataForm,
              end: val,
            });
          },
          watch: "start",
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          noWrapper: true,
          name: "durationHour",
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={["start", "end"]}
              isLongDuration={false}
            />
          ),
        },
      ],
    },
  ];

  const selectorSubmit = async () => {
    // Valider les formulaires
    try {
      await formRef.current.validateFields();
      await formRef2.current.validateFields();
    } catch (err) {
      notification.error({
        message: t("PrestationSelector.error"),
      });

      return;
    }

    const data = formRef.current.getFieldsValue(true);
    const data2 = formRef2.current.getFieldsValue(true);

    const datas = {
      ...data,
      ...data2,
    };

    const { start, end } = datas;

    const startDate = dayjs(start);
    const endDate = dayjs(end);

    // Vérifier les chevauchements entre les créneaux
    const checkOverlap = (start, end) => {
      const prestationsForDay = prestationSearch.filter(prestation => {
        const prestationStart = dayjs(prestation.finalStartDate);
        const prestationEnd = dayjs(prestation.finalEndDate);

        return (
          start.isBetween(prestationStart, prestationEnd, null, "[]") ||
          end.isBetween(prestationStart, prestationEnd, null, "[]") ||
          prestationStart.isBetween(start, end, null, "[]") ||
          prestationEnd.isBetween(start, end, null, "[]")
        );
      });

      return prestationsForDay.length > 0;
    };

    const msg = t("PrestationSelector.errorOverlap");

    if (checkOverlap(startDate, endDate)) {
      notification.error({
        message: msg,
      });

      formRef2.current.setFields([
        {
          name: "start",
          errors: [""],
        },
        {
          name: "end",
          errors: [""],
        },
        {
          name: "durationHour",
          errors: [msg],
        },
      ]);

      return;
    }

    // Vérifier les créneaux dans les horaires de vacances
    const holidays = shedules.filter(schedule => schedule.type === "holiday");

    for (let holiday of holidays) {
      const dateFrom = dayjs(holiday.dateFrom);
      const dateTo = dayjs(holiday.dateTo);

      if (
        startDate.isBetween(dateFrom, dateTo, "minute", "[)") ||
        endDate.isBetween(dateFrom, dateTo, "minute", "(]") ||
        startDate.isSame(dateFrom, "minute") ||
        endDate.isSame(dateTo, "minute")
      ) {
        notification.error({
          message: msg,
        });
        formRef2.current.setFields([
          {
            name: "start",
            errors: [""],
          },
          {
            name: "end",
            errors: [""],
          },
          {
            name: "durationHour",
            errors: [msg],
          },
        ]);
        return;
      }
    }

    navigate(routes.prestations().new.path, {
      replace: true,
      state: {
        ...datas,
        start: datas.start.format(),
        end: datas.end.format(),
      },
    });
  };

  return (
    <>
      <PrestationHeader title={routes.prestations().selector.title} />
      <br />{" "}
      <CustomForm
        handleSubmit={selectorSubmit}
        dataSource={inputsSelector({
          user,
          setDataForm,
          dataForm,
          interpreteRef,
        })}
        labelCol={24}
        wrapperCol={24}
        refForm={formRef}
      />{" "}
      <RenderInterpretesSchedules
        interprete={dataForm.interprete}
        schedules={shedules.filter(e => e.type === "schedule")}
      />
      <br />
      {dataForm.interprete !== undefined && (
        <CustomForm
          dataSource={dateSelectorInputs}
          labelCol={24}
          wrapperCol={24}
          key={dataForm.interprete}
          refForm={formRef2}
        />
      )}
      <div style={{ textAlign: "right", paddingTop: 15 }}>
        <Button onClick={selectorSubmit} size={"middle"} type={"primary"}>
          {t("PrestationSelector.startPrestation")}
        </Button>
      </div>
    </>
  );
}
